import axios from 'axios'

let resource = {}
resource.list = params => {
  return axios.get('/sys/res/find', {params})
}
resource.del = params => {
  return axios.post('/sys/res/del', params)
}
resource.save = params => {
  return axios.post('/sys/res/update', params)
}
export default resource



// WEBPACK FOOTER //
// ./src/api/resource.js